import { Link } from "@amzn/awsui-components-react";
import { HealthStatus, SearchHistoryItem } from "../types";
import HealthStatusIndicator from "../components/common/HealthStatusIndicator";
import { devUserQuery } from "../helpers/devUser";

export const compareDates = (date1: string, date2: string): number => {
  const parseDate = (dateStr: string): Date => {
    const [datePart, timePart] = dateStr.split(", ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hours, minutes, seconds] = timePart.split(":").map(Number);
    return new Date(year, month - 1, day, hours, minutes, seconds);
  };

  const d1 = parseDate(date1);
  const d2 = parseDate(date2);

  return d1.getTime() - d2.getTime();
};

export const COLUMN_DEFINITIONS = [
  {
    id: "orderId",
    header: "Transaction Id",
    width: 550,
    cell: (item: SearchHistoryItem) => (
      <Link
        href={`?stage=${encodeURIComponent(item.stage)}${devUserQuery(
          item.user
        )}&transactionId=${encodeURIComponent(item.orderId)}`}
      >
        {item.orderId}
      </Link>
    ),
    sortingField: "orderId",
  },
  {
    id: "stage",
    header: "Stage",
    width: 100,
    cell: (item: SearchHistoryItem) => item.stage || "-",
    sortingField: "stage",
  },
  {
    id: "glProductGroup",
    header: "GL",
    minWidth: 100,
    cell: (item: SearchHistoryItem) => item.glProductGroup || "-",
    sortingField: "glProductGroup",
  },
  {
    id: "countryCode",
    header: "Country",
    cell: (item: SearchHistoryItem) => item.countryCode || "-",
    sortingField: "countryCode",
  },
  {
    id: "healthStatus",
    header: "Status",
    cell: (item: SearchHistoryItem) => (
      <HealthStatusIndicator
        healthStatus={(item.status || "unknown") as HealthStatus}
      />
    ),
    sortingField: "status",
  },
  {
    id: "date",
    header: "Last Accessed",
    cell: (item: SearchHistoryItem) => item.date || "-",
    sortingField: "date",
    sortingComparator: (a, b) => compareDates(a.date, b.date),
  },
];
